import React from 'react';

import { useIntl } from 'react-intl-next';

import { cssMap } from '@atlaskit/css';
import { Flex, Stack } from '@atlaskit/primitives/compiled';
import Skeleton from '@atlaskit/skeleton';
import { token } from '@atlaskit/tokens';
import VisuallyHidden from '@atlaskit/visually-hidden';

import { messages } from '../i18n/messages';

const DEFAULT_MENU_SKELETON_HEIGHT = 40;
const DEFAULT_CONTENT_HEIGHT = 9;

const menuSkeletonStyles = cssMap({
	wrapper: {
		height: `${DEFAULT_MENU_SKELETON_HEIGHT}px`,
		width: '100%',
		paddingLeft: token('space.050'),
		paddingRight: token('space.050'),
	},
});

// Copied from @atlassian/universal-create/skeleton-item to avoid circular dependency
export const SkeletonItem = ({
	testId,
	contentHeight = DEFAULT_CONTENT_HEIGHT,
}: {
	testId: string;
	contentHeight?: number;
}) => {
	const { formatMessage } = useIntl();
	return (
		<Stack xcss={menuSkeletonStyles.wrapper} alignBlock="center" testId={testId}>
			<Flex alignItems="center">
				<Skeleton testId="skeleton-item-v2" width="100%" height={contentHeight} isShimmering />
			</Flex>
			<VisuallyHidden>{formatMessage(messages.skeletonItemLoading)}</VisuallyHidden>
		</Stack>
	);
};
